
import notificationCenter from "../components/notificationCenter/notificationCenter"
import getCartNumMixin from "@/mixins/getCartNum"

export default {
  name: "NotificationCenterPage",
  components: {
    notificationCenter
  },
  mixins: [getCartNumMixin],
  data() {
    return {}
  },
  mounted() {
    document.title = this.$t("notification.title")
  }
}
